export { TestimonialCarousel } from './TestimonialCarousel';
export type { Props as TestimonialCarouselProps } from './TestimonialCarousel';
